import { fetchGestionMorasJson, normalizarAlertaCompromisos } from './gestionMorasApi';

export async function getAdminGestionMoras(filters = {}) {
  return fetchGestionMorasJson('/api/admin/gestion-moras', { params: filters });
}

export async function getAdminAlertaCompromisosLogin() {
  const data = await fetchGestionMorasJson('/api/admin/gestion-moras/alerta-login', {
    fallbackMessage: 'Error al obtener la alerta de compromisos',
  });

  return normalizarAlertaCompromisos(data.data);
}

export async function getAdminGestionMorasAsesores() {
  const data = await fetchGestionMorasJson('/api/admin/asesores', {
    fallbackMessage: 'Error al cargar asesores',
    requireSuccessFlag: false,
  });

  return {
    asesores: Array.isArray(data.asesores) ? data.asesores : [],
  };
}

export async function createAdminCompromisoPago(payload) {
  return fetchGestionMorasJson('/api/admin/gestion-moras/compromiso-pagos', {
    method: 'POST',
    payload,
    fallbackMessage: 'Error al registrar el compromiso de pago',
  });
}

export async function updateAdminCompromisoPago(compromisoId, payload) {
  return fetchGestionMorasJson(`/api/admin/gestion-moras/compromiso-pagos/${compromisoId}`, {
    method: 'PUT',
    payload,
    fallbackMessage: 'Error al actualizar el compromiso de pago',
  });
}

export async function deleteAdminCompromisoPago(compromisoId) {
  return fetchGestionMorasJson(`/api/admin/gestion-moras/compromiso-pagos/${compromisoId}`, {
    method: 'DELETE',
    fallbackMessage: 'Error al eliminar el compromiso de pago',
  });
}